import React from 'react'
import classNames from '../../lib/utils/classNames'

const Cell = (props) => (
  <div
    className={classNames([
      'table-cell',
      props.className || '',
      props.align === 'right' ? 'align-right' : '',
    ])}
    data-abbreviation={props.abbreviation}
    data-testid={props.testId || ''}
  >
    {props.children}
  </div>
)

export default Cell
